import { useBroadcastGetAllQuery } from 'hooks';
import { Navigate, useParams } from 'react-router-dom';

import { SkeletonPage } from 'components/common';
import { useAppLocation } from 'hooks/helpers';
import { broadcastRoutes } from 'router/broadcastRoutes';
import { useBroadcastStore } from 'store/broadcast';
import { BroadcastPageView } from './BroadcastPageView';
import { useBroadcastInitializer } from './useBroadcastInitializer';

export const BroadcastPage = () => {
  const { data, isLoading, isFetching } = useBroadcastGetAllQuery();
  const { isCreate, isNotFound } = useAppLocation(broadcastRoutes);
  const { broadcastId } = useParams<{ broadcastId: string }>();
  const { draft } = useBroadcastStore((state) => state);

  useBroadcastInitializer({ broadcasts: data ?? [] });

  if (isLoading) {
    return <SkeletonPage />;
  }

  if (draft.id && !broadcastId && !isCreate && !isNotFound) {
    return <Navigate replace to={broadcastRoutes.broadcastId(draft.id)} />;
  }

  if (data?.length && !broadcastId && !isCreate && !isNotFound) {
    return <Navigate replace to={broadcastRoutes.broadcastId(data[0].id)} />;
  }

  const isBroadcastPresent = data?.some(({ id }) => id === broadcastId);

  if (!isFetching && broadcastId && !isBroadcastPresent) {
    return <Navigate replace to={broadcastRoutes.notFound} />;
  }

  return <BroadcastPageView />;
};
